import React from 'react';
import SearchIcon from '../svg/SearchIcon';

interface SearchInputProps {
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search',
  className = '',
  inputClassName = '',
}) => {
  return (
    <div className={`relative  w-[15rem]  ${className}`}>
      <div className='absolute inset-y-0 left-0 pl-3  flex items-center pointer-events-none'>
        <SearchIcon />
      </div>
      <input
        className={`border-[0.06rem] py-[0.55rem] px-[0.88rem] dark:bg-primary-800 dark:border-primary-800  pl-10 w-full rounded-[0.25rem] placeholder-primary-300 dark:placeholder-primary-300  placeholder:text-sm text-primary-400 dark:text-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-300 dark:focus:ring-primary-950 ${inputClassName}`}
        type='search'
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchInput;
